<!-- form -->
<form [formGroup]="signInGroup" (ngSubmit)="authenticate()">
    <!-- corporateURL -->
    @if (!subDomain || !found) {
    <div class="form-group">
        <label for="corporateURL">Corporate URL</label>
        <div class="input-group input-group-merge">
            <input class="form-control" autocomplete="off" (keyup)="checkCorpURL()" formControlName="corporateURL" type="text" id="corporateURL" placeholder="Enter Corporate URL">
            <div class="input-group-append">
                <div class="input-group-text">
                    <span class="text-muted">.rockitdms.com</span>
                </div>
            </div>
        </div>
        @if (!found && !loading && checked) {
        <span class="text-danger">Corporate URL not found. Please Sign Up or change to valid Corporate URL.</span>
        }
    </div>
    }
    <!-- email adress input -->
    <div class="form-group">
        <label for="email">Email address</label>
        <input class="form-control" type="email" id="email" formControlName="email" placeholder="Enter email" autocomplete="off">
        @if ((email.invalid && email.dirty)) {
            <span class="text-danger">Email Address Invalid</span>
        }
    </div>
    <!-- password input -->
    <div class="form-group">
        <span class="text-muted float-right clickable" [routerLink]="['/reset-password']" tabindex="-1"><small>Forgot your
                password?</small></span>
        <label for="password">Password</label>
        <div class="input-group input-group-merge">
            <input class="form-control" formControlName="password" [type]="typePassword" id="password" placeholder="Enter password">
            <div class="input-group-append" (click)="changeTypePassword()" id="changeType">
                <div class="input-group-text">
                    @if (typePassword=='text') {
                    <span class="uil uil-eye"></span>
                    }
                    @if (typePassword!='text') {
                    <span class="uil uil-eye-slash"></span>
                    }
                </div>
            </div>
        </div>
        @if ((password.dirty && password.invalid)) {
        <span class="text-danger">Password is required</span>
        }
    </div>


    <!-- log in button -->
    <div class="form-group mb-0 text-center">
        <button class="btn btn-primary btn-block" type="submit" [disabled]="loading" id="submitSendInformation">
            @if (!loading) {
            <span class="mdi mdi-login"></span>
            }
            @if (loading) {
            <img src="../../../assets/images/loading.svg" alt="" height="20">
            }
            <span class="ml-2">Sign In</span>
        </button>
    </div>

</form>
<!-- end form-->